export default "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgIi9hc3NldHMvbG9nby5kMGM5ZmJlMy4wOGZlM2M0My1kNTFhLTRiNjMtODQ4MC1kZDFiMGY5MjllZGQucG5nIjs="